import { SEOVideoObject } from '../../types'
import { makeId } from '../utils'

export interface SEOGetVideoObjectInput {
  canonicalUrl: string
  title: string
  description: string
  contentUrl: string
  embedUrl: string
  uploadDate: string
  duration: string
  publisherId: string
  thumbnailUrl?: string[]
  inLanguage?: string
}

const DEFAULT_THUMBNAILS = ['https://static.jusbr.com/images/logo/logo-jusbrasil-1200-675.png']

export const getVideoObject = ({
  canonicalUrl,
  title,
  description,
  contentUrl,
  embedUrl,
  uploadDate,
  duration,
  publisherId,
  thumbnailUrl = DEFAULT_THUMBNAILS,
  inLanguage = 'pt-BR',
}: SEOGetVideoObjectInput): SEOVideoObject => ({
  '@type': 'VideoObject',
  '@id': makeId(canonicalUrl, 'video'),
  isPartOf: {
    '@id': makeId(canonicalUrl, 'webpage'),
  },
  name: title,
  description,
  thumbnailUrl,
  uploadDate,
  duration,
  contentUrl,
  embedUrl,
  inLanguage,
  publisher: {
    '@type': 'Organization',
    '@id': publisherId,
  },
  potentialAction: {
    '@type': 'WatchAction',
    target: canonicalUrl,
  },
})
